import "core-js/modules/es6.array.map";
import "core-js/modules/es6.string.trim";
import "core-js/modules/es6.regexp.search";
import "core-js/modules/es6.object.assign";
import "core-js/modules/es6.object.define-property";
import "core-js/modules/es6.array.for-each";
import "core-js/modules/es6.array.filter";
import "core-js/modules/es6.symbol";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es6.object.keys";
import "core-js/modules/es6.object.create";
import "core-js/modules/es6.regexp.search";
import "core-js/modules/es6.object.assign";
import "core-js/modules/es6.symbol";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es6.object.keys";

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _inheritsLoose(subClass, superClass) {
  subClass.prototype = Object.create(superClass.prototype);
  subClass.prototype.constructor = subClass;
  subClass.__proto__ = superClass;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    var ownKeys = Object.keys(source);

    if (typeof Object.getOwnPropertySymbols === 'function') {
      ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }

    ownKeys.forEach(function (key) {
      _defineProperty(target, key, source[key]);
    });
  }

  return target;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

import React, { Fragment } from 'react';
import styled from 'styled-components';
import queryString from 'query-string';
import debounce from 'lodash/debounce';
import assign from 'lodash/assign';
import isArray from 'lodash/isArray';
import * as productImportHelpers from '@papertrailio/js-core/helpers/product-import-helpers';
import { spacing } from '../../style/theme';
import Button from '../../components/Button';
import ProductsImporting from './ProductsImporting';
import NoResults from './NoResults';
import ResultsInfo from './ResultsInfo';
import SearchResultsWrapper from './SearchResultsWrapper';
import SearchResult from './SearchResult';

var Link = function Link(props) {
  return React.createElement("a", _extends({
    href: "#"
  }, props));
};

var ProductSearchWrapper = styled.div.withConfig({
  displayName: "ProductSearch__ProductSearchWrapper",
  componentId: "sc-5vlct-0"
})(["position:relative;"]);
var SearchResults = styled.div.withConfig({
  displayName: "ProductSearch__SearchResults",
  componentId: "sc-5vlct-1"
})(["max-height:275px;overflow:hidden;overflow-y:auto;padding:0 ", "px;"], spacing.base);
var YPaddedWrapper = styled.div.withConfig({
  displayName: "ProductSearch__YPaddedWrapper",
  componentId: "sc-5vlct-2"
})(["padding-top:", "px;padding-bottom:", "px;"], spacing.base, spacing.base);

var ProductSearch =
/*#__PURE__*/
function (_React$Component) {
  _inheritsLoose(ProductSearch, _React$Component);

  function ProductSearch(props) {
    var _this;

    _this = _React$Component.call(this, props) || this;

    _defineProperty(_assertThisInitialized(_this), "initialState", {
      currentString: '',
      searchStringRequested: '',
      searchStringResponse: '',
      importing: false,
      nextPage: null,
      totalResults: null,
      searchResults: null,
      canLoadMore: null
    });

    _defineProperty(_assertThisInitialized(_this), "state", _this.initialState);

    _defineProperty(_assertThisInitialized(_this), "searchEndpoint", null);

    _defineProperty(_assertThisInitialized(_this), "clearSearch", function () {
      return _this.setState(_this.initialState);
    });

    _defineProperty(_assertThisInitialized(_this), "handleChange", function (event) {
      var value = event.target.value;

      if (_this.importing) {
        return;
      }

      _this.clearSearch();

      _this.setState({
        currentString: value
      });

      if (value.length > 2) {
        _this.searchDebounced({
          q: value
        });
      }
    });

    _defineProperty(_assertThisInitialized(_this), "hasMorePages", function (collection) {
      var meta = collection.$metadata || collection.meta;
      return meta && meta.pagination && meta.pagination.current_page < meta.pagination.total_pages;
    });

    _defineProperty(_assertThisInitialized(_this), "loadMoreProducts", function (e) {
      e.preventDefault();

      _this.search({
        q: _this.state.currentString
      });
    });

    _defineProperty(_assertThisInitialized(_this), "nextPage", function (collection) {
      var meta = collection.$metadata || collection.meta;
      return meta && meta.pagination && meta.pagination.current_page + 1 || 1;
    });

    _defineProperty(_assertThisInitialized(_this), "search", function (params) {
      var queryParams = assign(_objectSpread({
        limit: 25,
        page: _this.state.nextPage || 1
      }, _this.props.manufacturer && {
        manufacturer: _this.props.manufacturer
      }), params); // Cancel search as user is still typing or cancelled

      if (_this.state.currentString !== params.q) {
        return;
      }

      _this.setState({
        searchStringRequested: params.q
      }, function () {
        // Send the data to the lead form handler
        fetch(_this.searchEndpoint + "?" + queryString.stringify(_objectSpread({}, queryParams, {
          q: queryParams.q.trim()
        }))).then(function (response) {
          return response.json();
        }).then(function (response) {
          response.queryString = params.q; // This extra check is needed for previous requests that are still pending

          if (_this.state.searchStringRequested !== response.queryString) {
            // Cancel search as user is still typing or cancelled
            return;
          }

          _this.setState({
            searchStringRequested: '',
            searchStringResponse: response.queryString,
            nextPage: _this.nextPage(response),
            totalResults: response.meta.pagination.total
          }); // Load more results


          if (isArray(_this.state.searchResults)) {
            _this.setState({
              searchResults: _this.state.searchResults.concat(response.data)
            });
          } // New search
          else {
              _this.setState({
                searchResults: response.data
              });
            }

          response.data.forEach(productImportHelpers.generateHighlightedValues);

          if (_this.hasMorePages(response)) {
            _this.setState({
              canLoadMore: true
            });
          } else {
            _this.setState({
              canLoadMore: false
            });
          }
        });
      });
    });

    _defineProperty(_assertThisInitialized(_this), "searchDebounced", debounce(_this.search, 1000));

    _defineProperty(_assertThisInitialized(_this), "render", function () {
      return React.createElement(ProductSearchWrapper, _extends({}, _this.props, {
        ref: function ref(node) {
          return _this.node = node;
        }
      }), React.createElement(Fragment, null, _this.props.searchIcon && _this.props.searchIcon(), _this.props.textInput(_this.handleChange, _this.state.currentString)), (_this.state.searchResults || _this.state.searchStringRequested) && React.createElement(SearchResultsWrapper, null, _this.state.importing && React.createElement(ProductsImporting, null), _this.state.searchResults && _this.state.searchResults.length === 0 && React.createElement(NoResults, {
        term: _this.state.searchStringResponse
      }), !_this.state.importing && _this.state.searchResults && _this.state.searchResults.length > 0 && React.createElement(ResultsInfo, {
        searchResults: _this.state.searchResults,
        totalResults: _this.state.totalResults
      }), !_this.state.importing && React.createElement(SearchResults, null, _this.state.searchResults && _this.state.searchResults.length > 0 && _this.state.searchResults.map(function (product) {
        return React.createElement(SearchResult, {
          key: product.id,
          product: product,
          searchResultClick: _this.props.searchResultClick,
          searchResultBtnText: _this.props.searchResultBtnText && _this.props.searchResultBtnText(product),
          onSearchResultBtnClick: _this.props.onSearchResultBtnClick
        });
      }), _this.state.searchStringRequested && React.createElement(YPaddedWrapper, null, React.createElement("span", null, "Please wait...")), _this.state.searchResults && !_this.state.searchStringRequested && _this.state.canLoadMore && React.createElement(YPaddedWrapper, null, React.createElement(Button, {
        small: true,
        theme: "primaryGreen",
        Link: Link,
        onClick: _this.loadMoreProducts
      }, "Load more")))));
    });

    _this.searchEndpoint = props.searchEndpoint;
    return _this;
  }

  return ProductSearch;
}(React.Component);

export default ProductSearch;